// (function () {
//   const root = document.querySelector('[data-guide-selector]');
//   if (!root) return;

//   const dataNode = root.querySelector('[data-guide-data]');
//   if (!dataNode) return;

//   let data;
//   try {
//     data = JSON.parse(dataNode.textContent);
//   } catch (error) {
//     return;
//   }

//   const papers = data.papers || [];

//   function paperRank(paper) {
//     const label = ((paper.title || '') + ' ' + (paper.id || '')).toLowerCase();
//     if (label.indexOf('vinyl') !== -1) return 1;
//     if (label.indexOf('sublimation') !== -1) return 3;
//     if (label.indexOf('sticker') !== -1) return 2;
//     return 9;
//   }

//   papers.sort(function (a, b) {
//     return paperRank(a) - paperRank(b);
//   });
//   const hero = root.querySelector('[data-guide-hero]');
//   const zoom = root.querySelector('[data-guide-zoom]');
//   const showing = root.querySelector('[data-guide-showing]');
//   const materialBlock = root.querySelector('[data-guide-material-block]');
//   const printerBlock = root.querySelector('[data-guide-printer-block]');
//   const materialIndex = root.querySelector('[data-guide-material-index]');
//   const printerIndex = root.querySelector('[data-guide-printer-index]');
//   const summary = root.querySelector('[data-guide-summary]');
//   const summarySteps = root.querySelector('[data-summary-steps]');
//   const summaryStepsValue = root.querySelector('[data-summary-steps-value]');
//   const summaryHands = root.querySelector('[data-summary-hands]');
//   const summaryHandsValue = root.querySelector('[data-summary-hands-value]');
//   const summaryCure = root.querySelector('[data-summary-cure]');
//   const summaryCureValue = root.querySelector('[data-summary-cure-value]');
//   const paperButtons = root.querySelectorAll('[data-paper-id]');
//   const printerButtons = root.querySelectorAll('[data-printer]');

//   const stepsRoot = root.querySelector('#guide-steps');
//   const stepTabs = root.querySelector('[data-step-tabs]');
//   const stepCurrent = root.querySelector('[data-step-current]');
//   const stepTotal = root.querySelector('[data-step-total]');
//   const stepBar = root.querySelector('[data-step-bar]');
//   const stepVisual = root.querySelector('[data-step-visual]');
//   const stepPhoto = root.querySelector('[data-step-photo]');
//   const stepImage = root.querySelector('[data-step-image]');
//   const stepKicker = root.querySelector('[data-step-kicker]');
//   const stepTitle = root.querySelector('[data-step-title]');
//   const stepText = root.querySelector('[data-step-text]');
//   const stepSettings = root.querySelector('[data-step-settings]');
//   const stepSettingsTitle = root.querySelector('[data-step-settings-title]');
//   const stepSettingsNote = root.querySelector('[data-step-settings-note]');
//   const stepSettingsRows = root.querySelector('[data-step-settings-rows]');
//   const stepPaths = root.querySelector('[data-step-paths]');
//   const stepFootnote = root.querySelector('[data-step-footnote]');
//   const stepChecks = root.querySelector('[data-step-checks]');
//   const stepCallout = root.querySelector('[data-step-callout]');
//   const stepCalloutIcon = root.querySelector('[data-step-callout-icon]');
//   const stepCalloutTitle = root.querySelector('[data-step-callout-title]');
//   const stepCalloutText = root.querySelector('[data-step-callout-text]');
//   const stepNext = root.querySelector('[data-step-next]');
//   const stepBack = root.querySelector('[data-step-back]');
//   const stepNav = root.querySelector('.guide-steps__nav');
//   const photos = data.photos || [];

//   const state = {
//     paperId: '',
//     materialId: '',
//     printer: '',
//     step: 0,
//     guideKey: ''
//   };

//   const applied = {
//     paperId: '',
//     materialId: '',
//     printer: ''
//   };

//   function findPaper(id) {
//     return papers.find(function (paper) {
//       return paper.id === id && !paper.comingSoon;
//     });
//   }

//   function sourceFor(paper, materialId) {
//     if (!paper) return null;
//     const id = arguments.length > 1 ? materialId : state.materialId;
//     if (paper.materials.length > 1) {
//       return paper.materials.find(function (material) {
//         return material.id === id;
//       }) || paper.materials[0];
//     }
//     if (paper.materials.length === 1) return paper.materials[0];
//     return paper;
//   }

//   function currentGuide() {
//     const paper = findPaper(applied.paperId);
//     const source = sourceFor(paper, applied.materialId);
//     return source && source[applied.printer] ? source[applied.printer] : null;
//   }

//   function setPressed(buttons, attr, value) {
//     buttons.forEach(function (button) {
//       const selected = button.getAttribute(attr) === value;
//       button.classList.toggle('is-selected', selected);
//       button.setAttribute('aria-checked', selected ? 'true' : 'false');
//     });
//   }

//   function showStat(node, valueNode, value) {
//     if (!node || !valueNode) return;
//     if (value) {
//       valueNode.textContent = value;
//       node.hidden = false;
//     } else {
//       node.hidden = true;
//     }
//   }

//   function render() {
//     const paper = findPaper(state.paperId);
//     if (!paper) return;
//     const source = sourceFor(paper);
//     const showMaterials = paper.materials.length > 1;
//     const guide = source && source[state.printer] ? source[state.printer] : null;
//     const heroUrl = (source && source.hero) || paper.hero || '';
//     const zoomUrl = (source && source.zoom) || paper.zoom || heroUrl;
//     const zoomWidth = (source && source.zoomWidth) || paper.zoomWidth || 0;
//     const zoomHeight = (source && source.zoomHeight) || paper.zoomHeight || 0;

//     if (hero) {
//       if (heroUrl) {
//         hero.src = heroUrl;
//         hero.alt = source && source.title ? paper.title + ', ' + source.title : paper.title;
//         hero.dataset.zoomSrc = zoomUrl;
//         hero.dataset.zoomWidth = String(zoomWidth || '');
//         hero.dataset.zoomHeight = String(zoomHeight || '');
//         hero.hidden = false;
//         hero.classList.add('is-zoomable');
//         hero.tabIndex = 0;
//         hero.setAttribute('role', 'button');
//         if (zoom) hero.setAttribute('aria-label', zoom.getAttribute('aria-label') || 'Zoom image');
//       } else {
//         hero.removeAttribute('src');
//         hero.removeAttribute('data-zoom-src');
//         hero.hidden = true;
//         hero.classList.remove('is-zoomable');
//         hero.removeAttribute('tabindex');
//         hero.removeAttribute('role');
//         hero.removeAttribute('aria-label');
//       }
//     }

//     if (zoom) zoom.hidden = !heroUrl;

//     if (showing) {
//       const parts = [paper.title];
//       if (showMaterials && source && source.title) parts.push(source.title);
//       showing.textContent = data.showingPrefix + ' ' + parts.join(' · ');
//       showing.hidden = false;
//     }

//     setPressed(paperButtons, 'data-paper-id', paper.id);

//     if (materialBlock) materialBlock.hidden = !showMaterials;
//     root.querySelectorAll('[data-materials-for]').forEach(function (panel) {
//       const active = showMaterials && panel.getAttribute('data-materials-for') === paper.id;
//       panel.hidden = !active;
//       if (active && source) {
//         setPressed(panel.querySelectorAll('[data-material-id]'), 'data-material-id', source.id);
//       }
//     });

//     if (materialIndex) materialIndex.textContent = '2';
//     if (printerIndex) printerIndex.textContent = showMaterials ? '3' : '2';

//     printerButtons.forEach(function (button) {
//       const key = button.getAttribute('data-printer');
//       const available = !!(source && source[key]);
//       button.hidden = false;
//       button.disabled = !available;
//       button.classList.toggle('is-soon', !available);
//       const selected = available && key === state.printer;
//       button.classList.toggle('is-selected', selected);
//       button.setAttribute('aria-checked', selected ? 'true' : 'false');
//     });
//     if (printerBlock) printerBlock.hidden = false;

//     if (summary) {
//       summary.hidden = !guide;
//       if (guide) {
//         showStat(summarySteps, summaryStepsValue, guide.steps ? String(guide.steps) : '');
//         showStat(summaryHands, summaryHandsValue, guide.handsOn);
//         showStat(summaryCure, summaryCureValue, guide.cure);
//       }
//     }

//     const params = new URLSearchParams(window.location.search);
//     params.set('paper', paper.id);
//     if (showMaterials && source) params.set('material', source.id);
//     else params.delete('material');
//     if (state.printer && source && source[state.printer]) params.set('printer', state.printer);
//     else params.delete('printer');
//     const next = window.location.pathname + '?' + params.toString();
//     window.history.replaceState({}, '', next);
//   }

//   function visibleSteps(guide) {
//     if (!guide || !guide.items) return [];
//     return guide.items.map(function (item, index) {
//       return { item: item, index: index };
//     }).filter(function (entry) {
//       const title = (entry.item.title || '').trim();
//       return title && title !== '-';
//     });
//   }

//   function navLabel(entry) {
//     const photo = photos[entry.index] || {};
//     return photo.nav || entry.item.title || '';
//   }

//   function settingsHeading() {
//     const paper = findPaper(applied.paperId);
//     const source = sourceFor(paper, applied.materialId);
//     const printerButton = root.querySelector('[data-printer="' + applied.printer + '"] .guide-selector__printer-name');
//     const printerLabel = printerButton ? printerButton.textContent.trim() : '';
//     let subject = '';
//     if (paper && paper.materials && paper.materials.length && source && source.title) {
//       subject = source.title;
//     } else if (paper && paper.title) {
//       subject = paper.title;
//     }
//     return [printerLabel, subject].filter(Boolean).join(' · ');
//   }

//   function renderStep(guide) {
//     if (!stepsRoot) return;
//     const visible = visibleSteps(guide);
//     if (!visible.length) {
//       stepsRoot.hidden = true;
//       return;
//     }

//     const key = applied.paperId + '|' + applied.materialId + '|' + applied.printer;
//     if (key !== state.guideKey) {
//       state.guideKey = key;
//       state.step = 0;
//     }
//     if (state.step >= visible.length) state.step = 0;

//     const current = visible[state.step];
//     const photo = photos[current.index] || {};
//     const total = visible.length;
//     const number = state.step + 1;

//     stepsRoot.hidden = false;
//     if (stepCurrent) stepCurrent.textContent = (data.stepWord || 'Step') + ' ' + number;
//     if (stepTotal) stepTotal.textContent = (data.ofWord || 'of') + ' ' + total;
//     if (stepBar) stepBar.style.width = ((number / total) * 100) + '%';
//     if (stepKicker) stepKicker.textContent = ((data.stepWord || 'Step') + ' ' + number + ' ' + (data.ofWord || 'of') + ' ' + total).toUpperCase();
//     if (stepTitle) stepTitle.textContent = current.item.title || '';
//     if (stepText) stepText.innerHTML = current.item.text || '';

//     const calloutTitle = current.item.calloutTitle || '';
//     const calloutText = current.item.calloutText || '';
//     const alert = photo.callout === 'alert';
//     if (stepCallout) {
//       stepCallout.hidden = !calloutTitle && !calloutText;
//       stepCallout.classList.toggle('is-alert', alert);
//     }
//     if (stepCalloutIcon) stepCalloutIcon.src = alert && data.alertIcon ? data.alertIcon : (data.tipIcon || stepCalloutIcon.src);
//     if (stepCalloutTitle) stepCalloutTitle.textContent = calloutTitle;
//     if (stepCalloutText) stepCalloutText.innerHTML = calloutText;

//     const settings = current.item.settings || [];
//     if (stepSettings) {
//       stepSettings.hidden = !settings.length;
//       if (stepSettingsTitle) stepSettingsTitle.textContent = settingsHeading();
//       if (stepSettingsNote) {
//         stepSettingsNote.textContent = current.item.note || '';
//         stepSettingsNote.hidden = !current.item.note;
//       }
//       if (stepSettingsRows) {
//         stepSettingsRows.innerHTML = '';
//         settings.forEach(function (row, index) {
//           const line = document.createElement('div');
//           line.className = 'guide-steps__settings-row';
//           const badge = document.createElement('span');
//           badge.className = 'guide-steps__settings-index';
//           badge.textContent = String(index + 1);
//           const label = document.createElement('span');
//           label.className = 'guide-steps__settings-label';
//           label.textContent = row.label || '';
//           const value = document.createElement('span');
//           value.className = 'guide-steps__settings-value';
//           value.textContent = row.value || '';
//           line.appendChild(badge);
//           line.appendChild(label);
//           line.appendChild(value);
//           stepSettingsRows.appendChild(line);
//         });
//       }
//     }
//     if (stepPaths) stepPaths.hidden = !settings.length;
//     if (stepFootnote) {
//       const footnote = current.item.footnote || '';
//       stepFootnote.textContent = footnote;
//       stepFootnote.hidden = !footnote;
//     }

//     if (stepChecks) {
//       const checks = current.item.checks || [];
//       stepChecks.innerHTML = '';
//       stepChecks.hidden = !checks.length;
//       checks.forEach(function (check) {
//         const ok = check.ok !== false;
//         const item = document.createElement('li');
//         const mark = document.createElement('span');
//         mark.className = 'guide-steps__check' + (ok ? '' : ' is-no');
//         const icon = document.createElement('img');
//         icon.src = ok ? data.checkIcon : data.crossIcon;
//         icon.alt = '';
//         icon.width = ok ? 12 : 11;
//         icon.height = ok ? 12 : 11;
//         mark.appendChild(icon);
//         const label = document.createElement('span');
//         label.textContent = check.text || '';
//         item.appendChild(mark);
//         item.appendChild(label);
//         stepChecks.appendChild(item);
//       });
//     }

//     if (stepVisual) stepVisual.style.background = photo.background || '#ddf3ff';
//     showStepPhoto(photo, current.item.title || '');

//     if (stepTabs) {
//       stepTabs.innerHTML = '';
//       visible.forEach(function (entry, index) {
//         const button = document.createElement('button');
//         button.type = 'button';
//         const done = index < state.step;
//         button.className = 'guide-steps__tab' + (index === state.step ? ' is-active' : '') + (done ? ' is-done' : '');
//         button.setAttribute('role', 'tab');
//         button.setAttribute('aria-selected', index === state.step ? 'true' : 'false');
//         const badge = document.createElement('span');
//         badge.className = 'guide-steps__tab-index';
//         if (done && data.checkIcon) {
//           const icon = document.createElement('img');
//           icon.src = data.checkIcon;
//           icon.alt = '';
//           icon.width = 12;
//           icon.height = 12;
//           badge.appendChild(icon);
//         } else {
//           badge.textContent = String(index + 1);
//         }
//         const label = document.createElement('span');
//         label.textContent = navLabel(entry);
//         button.appendChild(badge);
//         button.appendChild(label);
//         button.addEventListener('click', function () {
//           state.step = index;
//           renderStep(guide);
//         });
//         stepTabs.appendChild(button);
//       });
//       const activeTab = stepTabs.querySelector('.is-active');
//       if (activeTab && window.matchMedia('(max-width: 989px)').matches) {
//         window.requestAnimationFrame(function () {
//           const left = activeTab.offsetLeft - (stepTabs.clientWidth - activeTab.offsetWidth) / 2;
//           stepTabs.scrollTo({ left: Math.max(0, left) });
//         });
//       }
//     }

//     if (stepBack) {
//       stepBack.disabled = state.step === 0;
//       stepBack.hidden = false;
//     }

//     if (stepNext) {
//       const upcoming = visible[state.step + 1];
//       if (upcoming) {
//         stepNext.hidden = false;
//         stepNext.textContent = (data.nextPrefix || 'NEXT:') + ' ' + navLabel(upcoming).toUpperCase() + ' →';
//       } else {
//         stepNext.hidden = false;
//         stepNext.textContent = data.finishLabel || 'FINISH ✓';
//       }
//     }

//     pinStepNav();
//   }

//   let shownPhoto = null;
//   let shownTitle = '';

//   function stepPhotoUrl(photo) {
//     if (!photo) return '';
//     const narrow = window.matchMedia('(max-width: 989px)').matches;
//     if (narrow && photo.mobile) return photo.mobile;
//     return photo.image || '';
//   }

//   function showStepPhoto(photo, title) {
//     shownPhoto = photo || null;
//     shownTitle = title || '';
//     if (!stepPhoto || !stepImage) return;
//     const src = stepPhotoUrl(shownPhoto);
//     if (src) {
//       if (stepImage.getAttribute('src') !== src) stepImage.src = src;
//       stepImage.alt = shownTitle;
//       stepPhoto.hidden = false;
//     } else {
//       stepImage.removeAttribute('src');
//       stepPhoto.hidden = true;
//     }
//   }

//   function pinStepNav() {
//     if (!stepNav || !stepsRoot) return;
//     const mobile = window.matchMedia('(max-width: 989px)').matches;
//     if (!mobile || stepsRoot.hidden) {
//       stepNav.classList.remove('is-pinned');
//       return;
//     }
//     const section = stepsRoot.getBoundingClientRect();
//     const slot = stepNav.parentElement ? stepNav.parentElement.getBoundingClientRect() : section;
//     const inView = section.top < window.innerHeight && section.bottom > 160;
//     const below = slot.top > window.innerHeight - 12;
//     stepNav.classList.toggle('is-pinned', inView && below);
//   }

//   function selectPaper(id) {
//     const paper = findPaper(id);
//     if (!paper) return;
//     state.paperId = paper.id;
//     state.materialId = paper.materials.length ? paper.materials[0].id : '';
//     const source = sourceFor(paper);
//     state.printer = source && source.inkjet ? 'inkjet' : source && source.laser ? 'laser' : '';
//     render();
//   }

//   paperButtons.forEach(function (button) {
//     button.addEventListener('click', function () {
//       if (button.disabled) return;
//       selectPaper(button.getAttribute('data-paper-id'));
//     });
//   });

//   root.querySelectorAll('[data-material-id]').forEach(function (button) {
//     button.addEventListener('click', function () {
//       state.materialId = button.getAttribute('data-material-id');
//       const paper = findPaper(state.paperId);
//       const source = sourceFor(paper);
//       if (!source || !source[state.printer]) {
//         state.printer = source && source.inkjet ? 'inkjet' : source && source.laser ? 'laser' : '';
//       }
//       render();
//     });
//   });

//   printerButtons.forEach(function (button) {
//     button.addEventListener('click', function () {
//       if (button.disabled) return;
//       state.printer = button.getAttribute('data-printer');
//       render();
//     });
//   });

//   function openZoom() {
//     if (!hero || hero.hidden || !hero.dataset.zoomSrc || !window.theme || !window.theme.LoadPhotoswipe) return;
//     const width = parseInt(hero.dataset.zoomWidth, 10) || hero.naturalWidth || 1200;
//     const height = parseInt(hero.dataset.zoomHeight, 10) || hero.naturalHeight || 1200;
//     const rect = hero.getBoundingClientRect();
//     new window.theme.LoadPhotoswipe(
//       [{
//         src: hero.dataset.zoomSrc,
//         w: width,
//         h: height,
//         msrc: hero.currentSrc || hero.src
//       }],
//       {
//         history: false,
//         focus: false,
//         index: 0,
//         mainClass: 'pswp-zoom-gallery pswp-zoom-gallery--single',
//         showHideOpacity: true,
//         closeOnScroll: false,
//         closeOnVerticalDrag: false,
//         captionEl: false,
//         fullscreenEl: false,
//         shareEl: false,
//         counterEl: false,
//         arrowEl: false,
//         tapToClose: true,
//         maxSpreadZoom: 2,
//         getThumbBoundsFn: function () {
//           return {
//             x: rect.left,
//             y: rect.top + (window.scrollY || document.documentElement.scrollTop),
//             w: rect.width
//           };
//         }
//       }
//     );
//   }

//   if (hero) {
//     hero.addEventListener('click', openZoom);
//     hero.addEventListener('keyup', function (event) {
//       if (event.code === 'Enter') openZoom();
//     });
//   }

//   if (zoom) zoom.addEventListener('click', openZoom);

//   if (stepBack) {
//     stepBack.addEventListener('click', function () {
//       if (state.step < 1) return;
//       state.step -= 1;
//       renderStep(currentGuide());
//     });
//   }

//   if (stepNext) {
//     stepNext.addEventListener('click', function () {
//       const active = currentGuide();
//       const visible = visibleSteps(active);
//       if (state.step < visible.length - 1) {
//         state.step += 1;
//         renderStep(active);
//       }
//     });
//   }

//   const start = root.querySelector('[data-guide-start]');
//   if (start) {
//     start.addEventListener('click', function (event) {
//       event.preventDefault();
//       applied.paperId = state.paperId;
//       applied.materialId = state.materialId;
//       applied.printer = state.printer;
//       state.step = 0;
//       renderStep(currentGuide());
//       if (stepsRoot && !stepsRoot.hidden) {
//         stepsRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       }
//     });
//   }

//   window.addEventListener('scroll', pinStepNav, { passive: true });
//   window.addEventListener('resize', function () {
//     pinStepNav();
//     if (shownPhoto) showStepPhoto(shownPhoto, shownTitle);
//   });

//   const params = new URLSearchParams(window.location.search);
//   const requested = findPaper(params.get('paper'));
//   const first = papers.find(function (paper) {
//     return !paper.comingSoon;
//   });
//   const paper = requested || first;
//   if (!paper) return;

//   state.paperId = paper.id;
//   const requestedMaterial = paper.materials.find(function (material) {
//     return material.id === params.get('material');
//   });
//   state.materialId = requestedMaterial ? requestedMaterial.id : (paper.materials[0] ? paper.materials[0].id : '');
//   const source = sourceFor(paper);
//   const requestedPrinter = params.get('printer');
//   if (source && source[requestedPrinter]) state.printer = requestedPrinter;
//   else state.printer = source && source.inkjet ? 'inkjet' : source && source.laser ? 'laser' : '';
//   applied.paperId = state.paperId;
//   applied.materialId = state.materialId;
//   applied.printer = state.printer;
//   render();
//   renderStep(currentGuide());
// })();


(function () {
  const root = document.querySelector('[data-guide-selector]');
  if (!root) return;

  const dataNode = root.querySelector('[data-guide-data]');
  if (!dataNode) return;

  let data;
  try {
    data = JSON.parse(dataNode.textContent);
  } catch (error) {
    return;
  }

  const papers = data.papers || [];

  function paperRank(paper) {
    const label = ((paper.title || '') + ' ' + (paper.id || '')).toLowerCase();
    if (label.indexOf('vinyl') !== -1) return 1;
    if (label.indexOf('sublimation') !== -1) return 3;
    if (label.indexOf('sticker') !== -1) return 2;
    return 9;
  }

  papers.sort(function (a, b) {
    return paperRank(a) - paperRank(b);
  });
  const hero = root.querySelector('[data-guide-hero]');
  const zoom = root.querySelector('[data-guide-zoom]');
  const showing = root.querySelector('[data-guide-showing]');
  const materialBlock = root.querySelector('[data-guide-material-block]');
  const printerBlock = root.querySelector('[data-guide-printer-block]');
  const materialIndex = root.querySelector('[data-guide-material-index]');
  const printerIndex = root.querySelector('[data-guide-printer-index]');
  const summary = root.querySelector('[data-guide-summary]');
  const summarySteps = root.querySelector('[data-summary-steps]');
  const summaryStepsValue = root.querySelector('[data-summary-steps-value]');
  const summaryHands = root.querySelector('[data-summary-hands]');
  const summaryHandsValue = root.querySelector('[data-summary-hands-value]');
  const summaryCure = root.querySelector('[data-summary-cure]');
  const summaryCureValue = root.querySelector('[data-summary-cure-value]');
  const paperButtons = root.querySelectorAll('[data-paper-id]');
  const printerButtons = root.querySelectorAll('[data-printer]');

  const stepsRoot = root.querySelector('#guide-steps');
  const stepTabs = root.querySelector('[data-step-tabs]');
  const stepCurrent = root.querySelector('[data-step-current]');
  const stepTotal = root.querySelector('[data-step-total]');
  const stepBar = root.querySelector('[data-step-bar]');
  const stepVisual = root.querySelector('[data-step-visual]');
  const stepPhoto = root.querySelector('[data-step-photo]');
  const stepImage = root.querySelector('[data-step-image]');
  const stepKicker = root.querySelector('[data-step-kicker]');
  const stepTitle = root.querySelector('[data-step-title]');
  const stepText = root.querySelector('[data-step-text]');
  const stepSettings = root.querySelector('[data-step-settings]');
  const stepSettingsTitle = root.querySelector('[data-step-settings-title]');
  const stepSettingsNote = root.querySelector('[data-step-settings-note]');
  const stepSettingsRows = root.querySelector('[data-step-settings-rows]');
  const stepPaths = root.querySelector('[data-step-paths]');
  const stepFootnote = root.querySelector('[data-step-footnote]');
  const stepChecks = root.querySelector('[data-step-checks]');
  const stepCallout = root.querySelector('[data-step-callout]');
  const stepCalloutIcon = root.querySelector('[data-step-callout-icon]');
  const stepCalloutTitle = root.querySelector('[data-step-callout-title]');
  const stepCalloutText = root.querySelector('[data-step-callout-text]');
  const stepNext = root.querySelector('[data-step-next]');
  const stepBack = root.querySelector('[data-step-back]');
  const stepNav = root.querySelector('.guide-steps__nav');
  const photos = data.photos || [];

  const state = {
    paperId: '',
    materialId: '',
    printer: '',
    step: 0,
    guideKey: ''
  };

  const applied = {
    paperId: '',
    materialId: '',
    printer: ''
  };

  function findPaper(id) {
    return papers.find(function (paper) {
      return paper.id === id && !paper.comingSoon;
    });
  }

  function sourceFor(paper, materialId) {
    if (!paper) return null;
    const id = arguments.length > 1 ? materialId : state.materialId;
    if (paper.materials.length > 1) {
      return paper.materials.find(function (material) {
        return material.id === id;
      }) || paper.materials[0];
    }
    if (paper.materials.length === 1) return paper.materials[0];
    return paper;
  }

  function currentGuide() {
    const paper = findPaper(applied.paperId);
    const source = sourceFor(paper, applied.materialId);
    return source && source[applied.printer] ? source[applied.printer] : null;
  }

  // Copies the current selection into the steps and re-renders them right away.
  // renderStep resets to step 1 when the paper / material / printer combination changes,
  // and hides the steps block when the new combination has no guide.
  function syncSteps() {
    applied.paperId = state.paperId;
    applied.materialId = state.materialId;
    applied.printer = state.printer;
    renderStep(currentGuide());
  }

  function setPressed(buttons, attr, value) {
    buttons.forEach(function (button) {
      const selected = button.getAttribute(attr) === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
  }

  function showStat(node, valueNode, value) {
    if (!node || !valueNode) return;
    if (value) {
      valueNode.textContent = value;
      node.hidden = false;
    } else {
      node.hidden = true;
    }
  }

  function render() {
    const paper = findPaper(state.paperId);
    if (!paper) return;
    const source = sourceFor(paper);
    const showMaterials = paper.materials.length > 1;
    const guide = source && source[state.printer] ? source[state.printer] : null;
    const heroUrl = (source && source.hero) || paper.hero || '';
    const zoomUrl = (source && source.zoom) || paper.zoom || heroUrl;
    const zoomWidth = (source && source.zoomWidth) || paper.zoomWidth || 0;
    const zoomHeight = (source && source.zoomHeight) || paper.zoomHeight || 0;

    if (hero) {
      if (heroUrl) {
        hero.src = heroUrl;
        hero.alt = source && source.title ? paper.title + ', ' + source.title : paper.title;
        hero.dataset.zoomSrc = zoomUrl;
        hero.dataset.zoomWidth = String(zoomWidth || '');
        hero.dataset.zoomHeight = String(zoomHeight || '');
        hero.hidden = false;
        hero.classList.add('is-zoomable');
        hero.tabIndex = 0;
        hero.setAttribute('role', 'button');
        if (zoom) hero.setAttribute('aria-label', zoom.getAttribute('aria-label') || 'Zoom image');
      } else {
        hero.removeAttribute('src');
        hero.removeAttribute('data-zoom-src');
        hero.hidden = true;
        hero.classList.remove('is-zoomable');
        hero.removeAttribute('tabindex');
        hero.removeAttribute('role');
        hero.removeAttribute('aria-label');
      }
    }

    if (zoom) zoom.hidden = !heroUrl;

    if (showing) {
      const parts = [paper.title];
      if (showMaterials && source && source.title) parts.push(source.title);
      showing.textContent = data.showingPrefix + ' ' + parts.join(' · ');
      showing.hidden = false;
    }

    setPressed(paperButtons, 'data-paper-id', paper.id);

    if (materialBlock) materialBlock.hidden = !showMaterials;
    root.querySelectorAll('[data-materials-for]').forEach(function (panel) {
      const active = showMaterials && panel.getAttribute('data-materials-for') === paper.id;
      panel.hidden = !active;
      if (active && source) {
        setPressed(panel.querySelectorAll('[data-material-id]'), 'data-material-id', source.id);
      }
    });

    if (materialIndex) materialIndex.textContent = '2';
    if (printerIndex) printerIndex.textContent = showMaterials ? '3' : '2';

    printerButtons.forEach(function (button) {
      const key = button.getAttribute('data-printer');
      const available = !!(source && source[key]);
      button.hidden = false;
      button.disabled = !available;
      button.classList.toggle('is-soon', !available);
      const selected = available && key === state.printer;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    if (printerBlock) printerBlock.hidden = false;

    if (summary) {
      summary.hidden = !guide;
      if (guide) {
        showStat(summarySteps, summaryStepsValue, guide.steps ? String(guide.steps) : '');
        showStat(summaryHands, summaryHandsValue, guide.handsOn);
        showStat(summaryCure, summaryCureValue, guide.cure);
      }
    }

    const params = new URLSearchParams(window.location.search);
    params.set('paper', paper.id);
    if (showMaterials && source) params.set('material', source.id);
    else params.delete('material');
    if (state.printer && source && source[state.printer]) params.set('printer', state.printer);
    else params.delete('printer');
    const next = window.location.pathname + '?' + params.toString();
    window.history.replaceState({}, '', next);
  }

  function visibleSteps(guide) {
    if (!guide || !guide.items) return [];
    return guide.items.map(function (item, index) {
      return { item: item, index: index };
    }).filter(function (entry) {
      const title = (entry.item.title || '').trim();
      return title && title !== '-';
    });
  }

  function navLabel(entry) {
    const photo = photos[entry.index] || {};
    return photo.nav || entry.item.title || '';
  }

  function settingsHeading() {
    const paper = findPaper(applied.paperId);
    const source = sourceFor(paper, applied.materialId);
    const printerButton = root.querySelector('[data-printer="' + applied.printer + '"] .guide-selector__printer-name');
    const printerLabel = printerButton ? printerButton.textContent.trim() : '';
    let subject = '';
    if (paper && paper.materials && paper.materials.length && source && source.title) {
      subject = source.title;
    } else if (paper && paper.title) {
      subject = paper.title;
    }
    return [printerLabel, subject].filter(Boolean).join(' · ');
  }

  function renderStep(guide) {
    if (!stepsRoot) return;
    const visible = visibleSteps(guide);
    if (!visible.length) {
      stepsRoot.hidden = true;
      pinStepNav();
      return;
    }

    const key = applied.paperId + '|' + applied.materialId + '|' + applied.printer;
    if (key !== state.guideKey) {
      state.guideKey = key;
      state.step = 0;
    }
    if (state.step >= visible.length) state.step = 0;

    const current = visible[state.step];
    const photo = photos[current.index] || {};
    const total = visible.length;
    const number = state.step + 1;

    stepsRoot.hidden = false;
    if (stepCurrent) stepCurrent.textContent = (data.stepWord || 'Step') + ' ' + number;
    if (stepTotal) stepTotal.textContent = (data.ofWord || 'of') + ' ' + total;
    if (stepBar) stepBar.style.width = ((number / total) * 100) + '%';
    if (stepKicker) stepKicker.textContent = ((data.stepWord || 'Step') + ' ' + number + ' ' + (data.ofWord || 'of') + ' ' + total).toUpperCase();
    if (stepTitle) stepTitle.textContent = current.item.title || '';
    if (stepText) stepText.innerHTML = current.item.text || '';

    const calloutTitle = current.item.calloutTitle || '';
    const calloutText = current.item.calloutText || '';
    const alert = photo.callout === 'alert';
    if (stepCallout) {
      stepCallout.hidden = !calloutTitle && !calloutText;
      stepCallout.classList.toggle('is-alert', alert);
    }
    if (stepCalloutIcon) stepCalloutIcon.src = alert && data.alertIcon ? data.alertIcon : (data.tipIcon || stepCalloutIcon.src);
    if (stepCalloutTitle) stepCalloutTitle.textContent = calloutTitle;
    if (stepCalloutText) stepCalloutText.innerHTML = calloutText;

    const settings = current.item.settings || [];
    if (stepSettings) {
      stepSettings.hidden = !settings.length;
      if (stepSettingsTitle) stepSettingsTitle.textContent = settingsHeading();
      if (stepSettingsNote) {
        stepSettingsNote.textContent = current.item.note || '';
        stepSettingsNote.hidden = !current.item.note;
      }
      if (stepSettingsRows) {
        stepSettingsRows.innerHTML = '';
        settings.forEach(function (row, index) {
          const line = document.createElement('div');
          line.className = 'guide-steps__settings-row';
          const badge = document.createElement('span');
          badge.className = 'guide-steps__settings-index';
          badge.textContent = String(index + 1);
          const label = document.createElement('span');
          label.className = 'guide-steps__settings-label';
          label.textContent = row.label || '';
          const value = document.createElement('span');
          value.className = 'guide-steps__settings-value';
          value.textContent = row.value || '';
          line.appendChild(badge);
          line.appendChild(label);
          line.appendChild(value);
          stepSettingsRows.appendChild(line);
        });
      }
    }
    if (stepPaths) stepPaths.hidden = !settings.length;
    if (stepFootnote) {
      const footnote = current.item.footnote || '';
      stepFootnote.textContent = footnote;
      stepFootnote.hidden = !footnote;
    }

    if (stepChecks) {
      const checks = current.item.checks || [];
      stepChecks.innerHTML = '';
      stepChecks.hidden = !checks.length;
      checks.forEach(function (check) {
        const ok = check.ok !== false;
        const item = document.createElement('li');
        const mark = document.createElement('span');
        mark.className = 'guide-steps__check' + (ok ? '' : ' is-no');
        const icon = document.createElement('img');
        icon.src = ok ? data.checkIcon : data.crossIcon;
        icon.alt = '';
        icon.width = ok ? 12 : 11;
        icon.height = ok ? 12 : 11;
        mark.appendChild(icon);
        const label = document.createElement('span');
        label.textContent = check.text || '';
        item.appendChild(mark);
        item.appendChild(label);
        stepChecks.appendChild(item);
      });
    }

    if (stepVisual) stepVisual.style.background = photo.background || '#ddf3ff';
    showStepPhoto(photo, current.item.title || '');

    if (stepTabs) {
      stepTabs.innerHTML = '';
      visible.forEach(function (entry, index) {
        const button = document.createElement('button');
        button.type = 'button';
        const done = index < state.step;
        button.className = 'guide-steps__tab' + (index === state.step ? ' is-active' : '') + (done ? ' is-done' : '');
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', index === state.step ? 'true' : 'false');
        const badge = document.createElement('span');
        badge.className = 'guide-steps__tab-index';
        if (done && data.checkIcon) {
          const icon = document.createElement('img');
          icon.src = data.checkIcon;
          icon.alt = '';
          icon.width = 12;
          icon.height = 12;
          badge.appendChild(icon);
        } else {
          badge.textContent = String(index + 1);
        }
        const label = document.createElement('span');
        label.textContent = navLabel(entry);
        button.appendChild(badge);
        button.appendChild(label);
        button.addEventListener('click', function () {
          state.step = index;
          renderStep(guide);
        });
        stepTabs.appendChild(button);
      });
      const activeTab = stepTabs.querySelector('.is-active');
      if (activeTab && window.matchMedia('(max-width: 989px)').matches) {
        window.requestAnimationFrame(function () {
          const left = activeTab.offsetLeft - (stepTabs.clientWidth - activeTab.offsetWidth) / 2;
          stepTabs.scrollTo({ left: Math.max(0, left) });
        });
      }
    }

    if (stepBack) {
      stepBack.disabled = state.step === 0;
      stepBack.hidden = false;
    }

    if (stepNext) {
      const upcoming = visible[state.step + 1];
      if (upcoming) {
        stepNext.hidden = false;
        stepNext.textContent = (data.nextPrefix || 'NEXT:') + ' ' + navLabel(upcoming).toUpperCase() + ' →';
      } else {
        stepNext.hidden = false;
        stepNext.textContent = data.finishLabel || 'FINISH ✓';
      }
    }

    pinStepNav();
  }

  let shownPhoto = null;
  let shownTitle = '';

  function stepPhotoUrl(photo) {
    if (!photo) return '';
    const narrow = window.matchMedia('(max-width: 989px)').matches;
    if (narrow && photo.mobile) return photo.mobile;
    return photo.image || '';
  }

  function showStepPhoto(photo, title) {
    shownPhoto = photo || null;
    shownTitle = title || '';
    if (!stepPhoto || !stepImage) return;
    const src = stepPhotoUrl(shownPhoto);
    if (src) {
      if (stepImage.getAttribute('src') !== src) stepImage.src = src;
      stepImage.alt = shownTitle;
      stepPhoto.hidden = false;
    } else {
      stepImage.removeAttribute('src');
      stepPhoto.hidden = true;
    }
  }

  function pinStepNav() {
    if (!stepNav || !stepsRoot) return;
    const mobile = window.matchMedia('(max-width: 989px)').matches;
    if (!mobile || stepsRoot.hidden) {
      stepNav.classList.remove('is-pinned');
      return;
    }
    const section = stepsRoot.getBoundingClientRect();
    const slot = stepNav.parentElement ? stepNav.parentElement.getBoundingClientRect() : section;
    const inView = section.top < window.innerHeight && section.bottom > 160;
    const below = slot.top > window.innerHeight - 12;
    stepNav.classList.toggle('is-pinned', inView && below);
  }

  function selectPaper(id) {
    const paper = findPaper(id);
    if (!paper) return;
    state.paperId = paper.id;
    state.materialId = paper.materials.length ? paper.materials[0].id : '';
    const source = sourceFor(paper);
    state.printer = source && source.inkjet ? 'inkjet' : source && source.laser ? 'laser' : '';
    render();
    syncSteps();
  }

  paperButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return;
      selectPaper(button.getAttribute('data-paper-id'));
    });
  });

  root.querySelectorAll('[data-material-id]').forEach(function (button) {
    button.addEventListener('click', function () {
      state.materialId = button.getAttribute('data-material-id');
      const paper = findPaper(state.paperId);
      const source = sourceFor(paper);
      if (!source || !source[state.printer]) {
        state.printer = source && source.inkjet ? 'inkjet' : source && source.laser ? 'laser' : '';
      }
      render();
      syncSteps();
    });
  });

  printerButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return;
      state.printer = button.getAttribute('data-printer');
      render();
      syncSteps();
    });
  });

  function openZoom() {
    if (!hero || hero.hidden || !hero.dataset.zoomSrc || !window.theme || !window.theme.LoadPhotoswipe) return;
    const width = parseInt(hero.dataset.zoomWidth, 10) || hero.naturalWidth || 1200;
    const height = parseInt(hero.dataset.zoomHeight, 10) || hero.naturalHeight || 1200;
    const rect = hero.getBoundingClientRect();
    new window.theme.LoadPhotoswipe(
      [{
        src: hero.dataset.zoomSrc,
        w: width,
        h: height,
        msrc: hero.currentSrc || hero.src
      }],
      {
        history: false,
        focus: false,
        index: 0,
        mainClass: 'pswp-zoom-gallery pswp-zoom-gallery--single',
        showHideOpacity: true,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        fullscreenEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: false,
        tapToClose: true,
        maxSpreadZoom: 2,
        getThumbBoundsFn: function () {
          return {
            x: rect.left,
            y: rect.top + (window.scrollY || document.documentElement.scrollTop),
            w: rect.width
          };
        }
      }
    );
  }

  if (hero) {
    hero.addEventListener('click', openZoom);
    hero.addEventListener('keyup', function (event) {
      if (event.code === 'Enter') openZoom();
    });
  }

  if (zoom) zoom.addEventListener('click', openZoom);

  if (stepBack) {
    stepBack.addEventListener('click', function () {
      if (state.step < 1) return;
      state.step -= 1;
      renderStep(currentGuide());
    });
  }

  if (stepNext) {
    stepNext.addEventListener('click', function () {
      const active = currentGuide();
      const visible = visibleSteps(active);
      if (state.step < visible.length - 1) {
        state.step += 1;
        renderStep(active);
      }
    });
  }

  const start = root.querySelector('[data-guide-start]');
  if (start) {
    start.addEventListener('click', function (event) {
      event.preventDefault();
      // Steps are already in sync with the selection; the button starts from step 1 and scrolls down.
      state.step = 0;
      syncSteps();
      if (stepsRoot && !stepsRoot.hidden) {
        stepsRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  window.addEventListener('scroll', pinStepNav, { passive: true });
  window.addEventListener('resize', function () {
    pinStepNav();
    if (shownPhoto) showStepPhoto(shownPhoto, shownTitle);
  });

  const params = new URLSearchParams(window.location.search);
  const requested = findPaper(params.get('paper'));
  const first = papers.find(function (paper) {
    return !paper.comingSoon;
  });
  const paper = requested || first;
  if (!paper) return;

  state.paperId = paper.id;
  const requestedMaterial = paper.materials.find(function (material) {
    return material.id === params.get('material');
  });
  state.materialId = requestedMaterial ? requestedMaterial.id : (paper.materials[0] ? paper.materials[0].id : '');
  const source = sourceFor(paper);
  const requestedPrinter = params.get('printer');
  if (source && source[requestedPrinter]) state.printer = requestedPrinter;
  else state.printer = source && source.inkjet ? 'inkjet' : source && source.laser ? 'laser' : '';
  render();
  syncSteps();
})();